// extracted by mini-css-extract-plugin
module.exports = {"item":"TopCountries_item__PLNNJ","flag":"TopCountries_flag__ornCi","price":"TopCountries_price__BLoJl"};